export default function() {
    return `@page {margin:0 10mm}
    h3 {text-align:center}
    table {border-collapse: collapse;}
    thead {background:#F8F8F9}
    thead td {color:#909399;font-weight:bold;}
    td {padding:12px 0;text-align:center;font-size:14px;color:#555;}`
}